import styled from '@emotion/styled'

export const PrivacyWrapper = styled.div`
  width: 100%;
`
